export default __webpack_public_path__ + "static/media/Graph Setting.cb6c1270b7e6f921214916ffc44694e3.svg";